import script from "./PortfolioScopes.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioScopes.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioScopes.vue?vue&type=style&index=0&id=02f77311&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f77311"]])

export default __exports__